module.exports = __webpack_public_path__ + "img/Roboto-Bold.57888be.svg";